import React from 'react';
import { Eyebrow } from './ui/Eyebrow';
import { systemStats, tracks } from '../data/content';
export function SystemSection() {
  return <section className="border-b border-ink/40 bg-ink text-cream" data-id="element-221" data-mp="3girex8kh47xr">
      <div className="mx-auto max-w-6xl px-5 py-20 lg:py-24" data-id="element-222" data-mp="3bhtyp1j0xnyw">
        <div className="grid gap-14 lg:grid-cols-[1.1fr_0.9fr] lg:gap-20" data-id="element-223" data-mp="36jsfmglllonf">
          <div data-id="element-224" data-mp="36lwj4xfl4ln6">
            <Eyebrow tone="light" data-id="element-225" data-mp="31kpa6v1phgex">El sistema más completo para profes de piano y guitarra</Eyebrow>
            <h2 className="mt-4 font-display text-4xl font-semibold leading-none tracking-tight sm:text-5xl" data-id="element-226" data-mp="2wu0jhhxuongu">
              El Profe de Guitarra
            </h2>
            <p className="mt-5 font-display text-xl italic leading-snug text-cream/80 sm:text-2xl" data-id="element-227" data-mp="2ssx2ut7zanek">
              El sistema de enseñanza «anti-abandono» en 6 volúmenes.
            </p>
            <p className="mt-6 max-w-prose text-[15px] leading-relaxed text-cream/75" data-id="element-228" data-mp="2iswgsziq5t6o">
              Más de 300 páginas con planes de clase completos, ejercicios profesionales, juegos de
              lectura, guías de técnica y herramientas para gestionar tu estudio. No es un libro de
              teoría: es una caja de herramientas profesional, ya preparada para vos.
            </p>
            <p className="mt-4 max-w-prose text-[15px] leading-relaxed text-cream/75" data-id="element-229" data-mp="u239t56zaj70">
              Todo se entrega en PDF listo para imprimir y llega a tu email. Sin videos, sin
              audiolibros, sin plataformas donde loguearte.
            </p>
          </div>

          <dl className="grid grid-cols-2 gap-px overflow-hidden rounded-xl bg-cream/15" data-id="element-230" data-mp="1roisgab55mw5">
            {systemStats.map(stat => <div key={stat.label} className="bg-ink px-6 py-8" data-id="element-231" data-mp="1cqi2ry0uw7ag">
                <dt className="text-[10px] font-semibold uppercase tracking-eyebrow text-cream/50" data-id="element-232" data-mp="1hqcrbux5sksc">
                  {stat.label}
                </dt>
                <dd className="mt-3 font-display text-4xl font-semibold leading-none text-cream" data-id="element-233" data-mp="1atft6nlr89n">
                  {stat.value}
                </dd>
              </div>)}
          </dl>
        </div>

        <div className="mt-16 border-t border-cream/15 pt-10" data-id="element-234" data-mp="2907imxj7k44i">
          <div className="flex flex-col gap-2 sm:flex-row sm:items-baseline sm:justify-between" data-id="element-235" data-mp="24031d5ah75d8">
            <Eyebrow tone="light" data-id="element-236" data-mp="1z79x0iix5z1o">Cobertura total</Eyebrow>
            <p className="text-[13px] text-cream/70" data-id="element-237" data-mp="1u98cdt5uhro3">
              De principiante a avanzado · Niños, adolescentes y adultos
            </p>
          </div>

          <ol className="mt-8 grid gap-x-8 gap-y-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-238" data-mp="1pboyiud27gwo">
            {tracks.map(track => <li key={track.number} className="flex items-baseline gap-4 border-b border-cream/10 pb-4" data-id="element-239" data-mp="1lamw64nuioqh">
                <span className="font-display text-lg text-accent" data-id="element-240" data-mp="1bbe6vp3xdyag">{track.number}</span>
                <span className="text-[15px] text-cream/90" data-id="element-241" data-mp="3anqfkkprsvsr">{track.label}</span>
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}